import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class IsoscelesTriangle extends AbstractShape {
	constructor( dimensions?: object ) {
		super( 'isosceles-triangle', dimensions );

		this.labelMappings = {
			base: 'width',
		};
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getBase(): Length {
		return this.cleanedPrimitives.base;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.base;
	}

	getSideLength(): Length {
		const halfWidth = this.getWidth().divide(2).in_mm();
		const height = this.getHeight().in_mm();

		const sideSquared = halfWidth * halfWidth + height * height;
		const sideLength = Math.sqrt(sideSquared);

		return Length.from_mm(sideLength);
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'base' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, this.getDimensionLineType('measurements-isosceles-triangle-height', focusedElement, forceRender) ), // Vertical line
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-isosceles-triangle-base', focusedElement, forceRender) ), // Horizontal line
				new DimensionLine( [ this.getWidth().divide(2).in_mm(), this.getHeight().in_mm() - 20 ], [this.getWidth().in_mm(), -20], this.renderDimensionLabel( 'side_length', this.getSideLength().in_cm() ), [40, 40], ratio ), // Horizontal line
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 50,
			base: 50,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			height: height.divide(2).in_cm(),
			base: width.divide(2).in_cm(),
		};
	}
}
